module.exports = __webpack_public_path__ + "img/icon_paperclip.1db6c2c6.svg";